import React from "react";
import { Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Blog from "./Pages/Blog";
import Cart from "./Pages/Cart";
import ChangePassword from "./Pages/ChangePassword";
import Checkout from "./Pages/Checkout";
import Contact from "./Pages/Contact";
import ForgotPassword from "./Pages/ForgotPassword";
import Login from "./Pages/Login";
import Profile from "./Pages/Profile";
import Register from "./Pages/Register";
import Shop from "./Pages/Shop";
import ShopProductDetails from "./Pages/ShopProductDetails";
import Proofs from "./Pages/CertificatePage.js";
import ViewOrder from "./Pages/ViewOrder.js";
import TermsAndConditions from "./Pages/TermsandConditions";
import ShippingAndDeliveryPolicy from "./Pages/ShippingAndDeliveryPolicy";
import Policies from "./Pages/PrivacyAndPolicy.js";
import CancellationPolicies from "./Pages/CancellationsAndRefundPolicy";


function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/login" element={<Login />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/register" element={<Register />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/certification" element={<Proofs />} />
        <Route path="/product/:id/:slug?" element={<ShopProductDetails />} />
        <Route path="/order/:orderId" element={<ViewOrder />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/cancellations-and-refund-policy" element={<CancellationPolicies />} />
        <Route path="/privacy-and-policy" element={<Policies />} />
        <Route path="/shipping-and-delivery-policy" element={<ShippingAndDeliveryPolicy />} />

      </Routes>
    </>
  );
}

export default App;
